import React from 'react';
import { Row, Col } from 'reactstrap';
import Aux from '../../hoc/Aux/Aux';
import MainMenu from '../Navigation/MainMenu/MainMenu';
import FundingPoolCounter from './FundingPoolCounter/FundingPoolCounter';
import PageNotFoundHeader from "./PageNotFoundHeader";

const header = (props) => (
    <Aux>
        <Row className="sticky-top">
            <FundingPoolCounter balance={props.balance}/>
        </Row>
        <Row>
            <Col className="p-0">
                <MainMenu primaryNavigation={props.primaryNavigation} primaryNavigationCTA={props.primaryNavigationCTA} />
            </Col>
        </Row>
        <Row>
            <Col className="px-0">
                {props.pageNotFound ? <PageNotFoundHeader/> : null}
            </Col>
        </Row>
    </Aux>
);

export default header;
